import React, { useEffect, useState, lazy, createElement } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { Card, CardHeader, CardContent } from '../components/Card';
import { Badge } from '../components/Badge';
import { BackgroundSlider } from '../components/BackgroundSlider';
import { ArrowRight, Check, MapPin, Calendar, Clock, Users, Target, Zap, Coffee, MessageSquare, Loader2 } from 'lucide-react';
interface NetworkingSalonExperiencePageProps {
  onNavigate?: (path: string) => void;
}
// Declare Paystack on window object
declare global {
  interface Window {
    PaystackPop: any;
  }
}
const cities = [{
  id: 'benin',
  name: 'Benin',
  date: 'March 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'February 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/Gg0acDUlz9WKb1bu4EPeEf'
}, {
  id: 'lagos',
  name: 'Lagos',
  date: 'April 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'March 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh'
}, {
  id: 'asaba',
  name: 'Asaba',
  date: 'April 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'March 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/DkaarUKWs7aJ6crRvDPOpt'
}, {
  id: 'uyo',
  name: 'Uyo',
  date: 'May 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'April 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/IJAovNsQlYb0lqR9wGcBvL'
}, {
  id: 'abuja',
  name: 'Abuja',
  date: 'May 2026',
  time: '8:00 AM WAT',
  earlyBirdDeadline: 'April 2026',
  price: 3500000,
  regularPrice: 5000000,
  currency: 'NGN',
  whatsapp: 'https://chat.whatsapp.com/KyuLep5qjEwHU6VR8tiBW9'
}, {
  id: 'canada',
  name: 'Canada',
  date: 'March 2026',
  time: null,
  earlyBirdDeadline: null,
  price: 10,
  regularPrice: 10,
  currency: 'USD',
  whatsapp: 'https://chat.whatsapp.com/EoH9cpC9aKf3UpVkypIJ8U',
  note: 'Payment unlocks Canada Networking Salon + Authority Engine Program'
}];
const previousSalonImages = ['https://cdn.magicpatterns.com/uploads/m5JGyWHTaDkAamj98wMGb7/IMG_6814.jpg', 'https://cdn.magicpatterns.com/uploads/2nbgMJBreHEfdmtK4vgrbJ/IMG_6832.jpg', 'https://cdn.magicpatterns.com/uploads/jnvfWnPf1cGdFuPZB9E2Zr/IMG_6896.jpg', 'https://cdn.magicpatterns.com/uploads/uaDfSY9NcCTXCVXkMyx1fb/IMG_7057.jpg', 'https://cdn.magicpatterns.com/uploads/7udF6MBUoAVRsQvjSHtT4c/IMG_7107.jpg', 'https://cdn.magicpatterns.com/uploads/8RNPHJGX9qBcGJfRDv1bKe/9E5A0116.jpg', 'https://cdn.magicpatterns.com/uploads/cQTusuTum4AGg19vNk8p6d/a27.jpg', 'https://cdn.magicpatterns.com/uploads/2xJjafNwsvs9iwnVTW9ejF/IMG_7290.jpg', 'https://cdn.magicpatterns.com/uploads/sP1AwUgBGEHhpiahzTd9b5/IMG_7305.jpg', 'https://cdn.magicpatterns.com/uploads/5WG1zLXYrsLdH2Tu3Hpc3m/IMG_7320.jpg', 'https://cdn.magicpatterns.com/uploads/9XTZkxvACPBaeCCvyLqoaa/SAV_8260.jpg', 'https://cdn.magicpatterns.com/uploads/tEcWAQhU5r3SoCg4m6csn8/SAV_8309.jpg', 'https://cdn.magicpatterns.com/uploads/1eUP3VkLsTvbJKiCJverQv/SAV_8332.jpg', 'https://cdn.magicpatterns.com/uploads/4sBVqYid4ahg9dxKEsLi3U/SAV_8340.jpg', 'https://cdn.magicpatterns.com/uploads/xuS1vdg3FiU6SAokqFyiMx/SAV_8448.jpg'];
export function NetworkingSalonExperiencePage({
  onNavigate
}: NetworkingSalonExperiencePageProps) {
  const [currentStep, setCurrentStep] = useState(1);
  const [isRegistering, setIsRegistering] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Form State
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    expertise: '',
    goal: '',
    instagram: '',
    twitter: '',
    tiktok: '',
    facebook: ''
  });
  // Load Paystack Script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.paystack.co/v1/inline.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCitySelect = (cityId: string) => {
    setSelectedCityId(cityId);
    setIsRegistering(true);
    // Scroll to registration form
    setTimeout(() => {
      const element = document.getElementById('registration-form');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  const nextStep = () => {
    // Basic validation
    if (currentStep === 1) {
      if (!formData.fullName || !formData.email || !formData.phone) {
        alert('Please fill in all required fields');
        return;
      }
    } else if (currentStep === 2) {
      if (!formData.expertise || !formData.goal) {
        alert('Please fill in all required fields');
        return;
      }
    } else if (currentStep === 3) {
      if (!formData.instagram || !formData.twitter || !formData.tiktok || !formData.facebook) {
        alert('Please answer all community check questions');
        return;
      }
    }
    setCurrentStep(prev => prev + 1);
  };
  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
  };
  const handlePayment = async () => {
    if (!selectedCityId) return;
    const city = cities.find(c => c.id === selectedCityId);
    if (!city) return;
    // Submit to Formspree first
    setIsSubmitting(true);
    try {
      const formspreeData = {
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        expertise: formData.expertise,
        goal: formData.goal,
        city: city.name,
        instagram: formData.instagram,
        twitter: formData.twitter,
        tiktok: formData.tiktok,
        facebook: formData.facebook
      };
      await fetch('https://formspree.io/f/maqqpgye', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formspreeData)
      });
    } catch (error) {
      console.error('Form submission error:', error);
    }
    setIsSubmitting(false);
    // Paystack integration with proper USD handling
    const handler = window.PaystackPop.setup({
      key: 'pk_live_c2f71547b29d95243a012d9ef2f8e03485d942e7',
      email: formData.email,
      amount: city.currency === 'USD' ? city.price * 100 : city.price,
      currency: city.currency,
      ref: 'NSE_' + city.id.toUpperCase() + '_' + Math.floor(Math.random() * 1000000000 + 1),
      metadata: {
        custom_fields: [{
          display_name: 'Full Name',
          variable_name: 'full_name',
          value: formData.fullName
        }, {
          display_name: 'Phone Number',
          variable_name: 'phone',
          value: formData.phone
        }, {
          display_name: 'City',
          variable_name: 'city',
          value: city.name
        }, {
          display_name: 'Expertise',
          variable_name: 'expertise',
          value: formData.expertise
        }]
      },
      callback: function (response: any) {
        alert(`You're In! Welcome to The Networking Salon Experience in ${city.name}. Redirecting you to the city WhatsApp group...`);
        window.location.href = city.whatsapp;
      },
      onClose: function () {
        console.log('Payment cancelled');
      }
    });
    handler.openIframe();
  };
  const scrollToCities = () => {
    const element = document.getElementById('cities');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933] font-sans selection:bg-salon-red/20 selection:text-[#1f2933]" data-id="element-1376">
      <Navbar onNavigate={onNavigate} hideInitiateAccess data-id="element-1377" />
      <BackgroundSlider data-id="element-1378" />

      {/* HERO SECTION */}
      <section className="relative border-b border-dashed border-[#9ca3af] py-24 sm:py-32 overflow-hidden" data-id="element-1379">
        <div className="absolute inset-0 z-10 bg-[linear-gradient(to_right,#9ca3af20_1px,transparent_1px),linear-gradient(to_bottom,#9ca3af20_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" data-id="element-1380" />

        <div className="relative z-20 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-1381">
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-1382">
            <img src="https://cdn.magicpatterns.com/uploads/a1ohPsjKDFpRBQVVygum9S/Logo_and_Teashirt_branding.png" alt="The Networking Salon" className="h-8 w-auto" data-id="element-1383" />
            <span className="font-mono text-xs text-[#9ca3af] tracking-widest uppercase" data-id="element-1384">
              presents
            </span>
          </div>

          <h1 className="mx-auto max-w-5xl text-4xl font-bold tracking-tight sm:text-6xl mb-4 text-[#1f2933]" data-id="element-1385">
            THE NETWORKING SALON EXPERIENCE
          </h1>

          <p className="mx-auto max-w-2xl text-lg font-mono text-[#1f2933]/80 mb-8" data-id="element-1386">
            A curated breakfast salon for professionals, founders, and creatives
            who want clarity, visibility, and leverage.
          </p>

          <div className="mb-12" data-id="element-1387">
            <h2 className="text-5xl md:text-7xl font-bold text-salon-red mb-2 tracking-tight" data-id="element-1388">
              FOCUS. CONSISTENCY. LEVERAGE.
            </h2>
            <p className="font-mono text-sm text-[#9ca3af] tracking-widest uppercase" data-id="element-1389">
              Building Authority, Visibility, and Business in the AI Era
            </p>
          </div>

          <Button size="large" rightIcon={<ArrowRight className="w-4 h-4" data-id="element-1391" />} onClick={scrollToCities} className="bg-salon-red hover:bg-salon-red/90 border-salon-red text-white" data-id="element-1390">
            REGISTER_NOW
          </Button>
        </div>
      </section>

      {/* HERO STORY */}
      <section className="py-24 border-b border-dashed border-[#9ca3af]" data-id="element-1392">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-1393">
          <div className="prose prose-lg mx-auto text-[#1f2933]/80" data-id="element-1394">
            <p className="text-xl font-bold text-[#1f2933] mb-8" data-id="element-1395">
              You are talented. You are doing the work. You are learning,
              building, trying.
            </p>
            <p data-id="element-1396">Yet somehow, it still feels like:</p>
            <ul className="list-none space-y-2 pl-0 mb-8" data-id="element-1397">
              <li className="flex items-start gap-3" data-id="element-1398">
                <span className="text-salon-red font-bold" data-id="element-1399">—</span>
                You're not as visible as you should be
              </li>
              <li className="flex items-start gap-3" data-id="element-1400">
                <span className="text-salon-red font-bold" data-id="element-1401">—</span>
                Opportunities don't come as easily as they should
              </li>
              <li className="flex items-start gap-3" data-id="element-1402">
                <span className="text-salon-red font-bold" data-id="element-1403">—</span>
                People don't fully understand what you do or why it matters
              </li>
            </ul>
            <p data-id="element-1404">
              You scroll through LinkedIn, Instagram, Twitter… And you see
              people with less depth, less skill, less experience — but more
              visibility, more authority, more leverage.
            </p>
            <p className="font-bold text-[#1f2933]" data-id="element-1405">
              It's frustrating. Not because you want attention — but because you
              know you have value.
            </p>
            <div className="bg-[#1f2933] text-white p-6 my-8 border-l-4 border-salon-red" data-id="element-1406">
              <p className="font-mono text-sm mb-0" data-id="element-1407">
                The real problem isn't effort. It isn't intelligence. It isn't
                even opportunity.
                <br data-id="element-1408" />
                <span className="text-salon-red font-bold text-lg" data-id="element-1409">
                  The real problem is positioning.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* THE REAL PAIN */}
      <section className="py-24 border-b border-dashed border-[#9ca3af] bg-[#e5e5e7]" data-id="element-1410">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1411">
          <div className="text-center mb-16" data-id="element-1412">
            <h2 className="font-mono text-xs font-bold text-salon-red mb-2" data-id="element-1413">
              01_DIAGNOSTICS
            </h2>
            <h3 className="text-3xl font-bold text-[#1f2933]" data-id="element-1414">
              The Three Traps
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1415">
            <Card className="bg-[#f5f5f7] border-salon-red" data-id="element-1416">
              <CardHeader title="The Generalist Trap" className="font-bold" data-id="element-1417" />
              <CardContent data-id="element-1418">
                <p className="font-mono text-sm text-[#1f2933]/70" data-id="element-1419">
                  Doing too many things and known for nothing. Good at what you
                  do, but invisible.
                </p>
              </CardContent>
            </Card>
            <Card className="bg-[#f5f5f7] border-salon-red" data-id="element-1420">
              <CardHeader title="The Effort Trap" className="font-bold" data-id="element-1421" />
              <CardContent data-id="element-1422">
                <p className="font-mono text-sm text-[#1f2933]/70" data-id="element-1423">
                  Working harder instead of working with leverage. Manual effort
                  vs systems.
                </p>
              </CardContent>
            </Card>
            <Card className="bg-[#f5f5f7] border-salon-red" data-id="element-1424">
              <CardHeader title="The Consistency Trap" className="font-bold" data-id="element-1425" />
              <CardContent data-id="element-1426">
                <p className="font-mono text-sm text-[#1f2933]/70" data-id="element-1427">
                  Posting inconsistently. Networking randomly. Chasing
                  opportunities instead of attracting them.
                </p>
              </CardContent>
            </Card>
          </div>

          <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-1428">
            <p className="text-lg text-[#1f2933]/80" data-id="element-1429">
              And slowly, quietly, this leads to career stagnation, burnout, and
              missed opportunities. Not because you lack ability — but because
              you lack clarity, consistency, and systems.
            </p>
          </div>
        </div>
      </section>

      {/* THE SHIFT */}
      <section className="py-24 border-b border-dashed border-[#9ca3af] bg-[#1f2933] text-white" data-id="element-1430">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-1431">
          <h2 className="font-mono text-xs font-bold text-salon-red mb-8" data-id="element-1432">
            02_THE_SHIFT
          </h2>
          <h3 className="text-3xl md:text-5xl font-bold mb-12 leading-tight" data-id="element-1433">
            What if 2026 didn't require you to do more… but to do the right
            things, repeatedly, with leverage?
          </h3>
          <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-1434">
            <div className="border-l-2 border-salon-red pl-4" data-id="element-1435">
              <p className="font-mono text-sm text-[#9ca3af] mb-2" data-id="element-1436">
                INSTEAD OF EVERYWHERE
              </p>
              <p className="font-bold text-xl" data-id="element-1437">Be Focused.</p>
            </div>
            <div className="border-l-2 border-salon-red pl-4" data-id="element-1438">
              <p className="font-mono text-sm text-[#9ca3af] mb-2" data-id="element-1439">
                INSTEAD OF START-STOP
              </p>
              <p className="font-bold text-xl" data-id="element-1440">Be Consistent.</p>
            </div>
            <div className="border-l-2 border-salon-red pl-4" data-id="element-1441">
              <p className="font-mono text-sm text-[#9ca3af] mb-2" data-id="element-1442">
                INSTEAD OF MANUAL
              </p>
              <p className="font-bold text-xl" data-id="element-1443">Be Leveraged.</p>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT YOU'LL LEARN */}
      <section className="py-24 border-b border-dashed border-[#9ca3af]" data-id="element-1444">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1445">
          <div className="mb-16" data-id="element-1446">
            <h2 className="font-mono text-xs font-bold text-salon-red mb-2" data-id="element-1447">
              03_CURRICULUM
            </h2>
            <h3 className="text-3xl font-bold text-[#1f2933]" data-id="element-1448">
              Three Core Sessions
            </h3>
          </div>

          <div className="space-y-12" data-id="element-1449">
            <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-1450">
              <div className="md:w-1/3" data-id="element-1451">
                <div className="text-6xl font-bold text-[#1f2933]/10 mb-2" data-id="element-1452">
                  01
                </div>
                <h3 className="text-2xl font-bold text-[#1f2933] mb-2" data-id="element-1453">
                  Strategic Positioning
                </h3>
                <Badge variant="secondary" className="bg-salon-red/10 text-salon-red border-salon-red" data-id="element-1454">
                  FOCUS
                </Badge>
              </div>
              <div className="md:w-2/3" data-id="element-1455">
                <p className="text-lg text-[#1f2933]/80 mb-4" data-id="element-1456">
                  Move from "I do many things" to "I am known for this."
                </p>
                <ul className="space-y-2" data-id="element-1457">
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1458">
                    <Check className="w-4 h-4 text-salon-red mt-1" data-id="element-1459" />
                    Clearly define what you should be known for
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1460">
                    <Check className="w-4 h-4 text-salon-red mt-1" data-id="element-1461" />
                    Stop confusing people with mixed messages
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1462">
                    <Check className="w-4 h-4 text-salon-red mt-1" data-id="element-1463" />
                    Position your skills, experience, and story strategically
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-start border-t border-dashed border-[#9ca3af] pt-12" data-id="element-1464">
              <div className="md:w-1/3" data-id="element-1465">
                <div className="text-6xl font-bold text-[#1f2933]/10 mb-2" data-id="element-1466">
                  02
                </div>
                <h3 className="text-2xl font-bold text-[#1f2933] mb-2" data-id="element-1467">
                  Authority Building
                </h3>
                <Badge variant="secondary" className="bg-salon-teal/10 text-salon-teal border-salon-teal" data-id="element-1468">
                  CONSISTENCY
                </Badge>
              </div>
              <div className="md:w-2/3" data-id="element-1469">
                <p className="text-lg text-[#1f2933]/80 mb-4" data-id="element-1470">
                  Authority isn't claimed. It's demonstrated — over time.
                </p>
                <ul className="space-y-2" data-id="element-1471">
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1472">
                    <Check className="w-4 h-4 text-salon-teal mt-1" data-id="element-1473" />
                    Turn your ideas into authority-based content
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1474">
                    <Check className="w-4 h-4 text-salon-teal mt-1" data-id="element-1475" />
                    Show up consistently without burnout
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1476">
                    <Check className="w-4 h-4 text-salon-teal mt-1" data-id="element-1477" />
                    Build trust before you ever pitch
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-8 items-start border-t border-dashed border-[#9ca3af] pt-12" data-id="element-1478">
              <div className="md:w-1/3" data-id="element-1479">
                <div className="text-6xl font-bold text-[#1f2933]/10 mb-2" data-id="element-1480">
                  03
                </div>
                <h3 className="text-2xl font-bold text-[#1f2933] mb-2" data-id="element-1481">
                  AI Optimization
                </h3>
                <Badge variant="secondary" className="bg-salon-yellow/10 text-salon-yellow border-salon-yellow" data-id="element-1482">
                  LEVERAGE
                </Badge>
              </div>
              <div className="md:w-2/3" data-id="element-1483">
                <p className="text-lg text-[#1f2933]/80 mb-4" data-id="element-1484">
                  AI is not here to replace you. It's here to multiply you.
                </p>
                <ul className="space-y-2" data-id="element-1485">
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1486">
                    <Check className="w-4 h-4 text-salon-yellow mt-1" data-id="element-1487" />
                    Use AI to clarify messaging
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1488">
                    <Check className="w-4 h-4 text-salon-yellow mt-1" data-id="element-1489" />
                    Create content faster without losing authenticity
                  </li>
                  <li className="flex items-start gap-2 text-sm text-[#1f2933]/70" data-id="element-1490">
                    <Check className="w-4 h-4 text-salon-yellow mt-1" data-id="element-1491" />
                    Build systems that save time and increase output
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* THE EXPERIENCE FLOW */}
      <section className="py-24 border-b border-dashed border-[#9ca3af] bg-[#f5f5f7]" data-id="element-1492">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1493">
          <div className="text-center mb-16" data-id="element-1494">
            <h2 className="font-mono text-xs font-bold text-salon-red mb-2" data-id="element-1495">
              04_THE_FLOW
            </h2>
            <h3 className="text-3xl font-bold text-[#1f2933]" data-id="element-1496">
              The Salon Experience
            </h3>
            <p className="mt-4 text-[#1f2933]/70" data-id="element-1497">
              No rushing. No noise. Just clarity, insight, and alignment.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 relative" data-id="element-1498">
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-[#9ca3af]/30 -z-10" data-id="element-1499"></div>

            <div className="bg-white p-6 border border-dashed border-[#9ca3af] text-center w-full md:w-auto relative" data-id="element-1500">
              <div className="w-10 h-10 bg-salon-red text-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1501">
                <Coffee className="w-5 h-5" data-id="element-1502" />
              </div>
              <h4 className="font-bold mb-1" data-id="element-1503">Breakfast</h4>
              <p className="text-xs text-[#9ca3af] font-mono" data-id="element-1504">Curated Meal</p>
            </div>

            <div className="bg-white p-6 border border-dashed border-[#9ca3af] text-center w-full md:w-auto relative" data-id="element-1505">
              <div className="w-10 h-10 bg-salon-teal text-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1506">
                <Zap className="w-5 h-5" data-id="element-1507" />
              </div>
              <h4 className="font-bold mb-1" data-id="element-1508">Learning</h4>
              <p className="text-xs text-[#9ca3af] font-mono" data-id="element-1509">Core Sessions</p>
            </div>

            <div className="bg-white p-6 border border-dashed border-[#9ca3af] text-center w-full md:w-auto relative" data-id="element-1510">
              <div className="w-10 h-10 bg-salon-yellow text-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1511">
                <MessageSquare className="w-5 h-5" data-id="element-1512" />
              </div>
              <h4 className="font-bold mb-1" data-id="element-1513">Conversation</h4>
              <p className="text-xs text-[#9ca3af] font-mono" data-id="element-1514">
                Guided Dialogue
              </p>
            </div>

            <div className="bg-white p-6 border border-dashed border-[#9ca3af] text-center w-full md:w-auto relative" data-id="element-1515">
              <div className="w-10 h-10 bg-[#1f2933] text-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1516">
                <Coffee className="w-5 h-5" data-id="element-1517" />
              </div>
              <h4 className="font-bold mb-1" data-id="element-1518">Lunch</h4>
              <p className="text-xs text-[#9ca3af] font-mono" data-id="element-1519">
                Networking Meal
              </p>
            </div>

            <div className="bg-white p-6 border border-dashed border-[#9ca3af] text-center w-full md:w-auto relative" data-id="element-1520">
              <div className="w-10 h-10 bg-[#1f2933] text-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1521">
                <Users className="w-5 h-5" data-id="element-1522" />
              </div>
              <h4 className="font-bold mb-1" data-id="element-1523">Connection</h4>
              <p className="text-xs text-[#9ca3af] font-mono" data-id="element-1524">
                Meaningful Networking
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PREVIOUS SALONS GALLERY */}
      <section className="py-24 border-b border-dashed border-[#9ca3af] bg-white overflow-hidden" data-id="element-1525">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-12" data-id="element-1526">
          <div className="text-center" data-id="element-1527">
            <h2 className="font-mono text-xs font-bold text-salon-red mb-2" data-id="element-1528">
              PREVIOUS_SALONS
            </h2>
            <h3 className="text-3xl font-bold text-[#1f2933]" data-id="element-1529">
              Lagos, Abuja, Benin, Warri, Port Harcourt
            </h3>
          </div>
        </div>

        <div className="relative" data-id="element-1530">
          <style data-id="element-1531">{`
            @keyframes scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .animate-scroll {
              animation: scroll 30s linear infinite;
            }
            .animate-scroll:hover {
              animation-play-state: paused;
            }
          `}</style>

          <div className="flex animate-scroll" data-id="element-1532">
            {[...previousSalonImages, ...previousSalonImages].map((img, idx) => <div key={idx} className="flex-shrink-0 w-80 h-80 mx-4" data-id="element-1533">
                  <img src={img} alt={`Previous Salon ${idx + 1}`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-300 border-2 border-[#9ca3af]" loading="lazy" data-id="element-1534" />
                </div>)}
          </div>
        </div>
      </section>

      {/* CITIES & REGISTRATION */}
      <section id="cities" className="py-24 border-b border-dashed border-[#9ca3af]" data-id="element-1535">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-1536">
          <div className="text-center mb-16" data-id="element-1537">
            <h2 className="font-mono text-xs font-bold text-salon-red mb-2" data-id="element-1538">
              05_LOCATIONS
            </h2>
            <h3 className="text-3xl font-bold text-[#1f2933]" data-id="element-1539">
              Choose Your City
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1540">
            {cities.map(city => <Card key={city.id} className="hover:border-salon-red transition-colors" data-id="element-1541">
                <CardHeader title={city.name} className="font-bold text-xl" data-id="element-1542" />
                <CardContent data-id="element-1543">
                  <div className="space-y-3 mb-4" data-id="element-1544">
                    <div className="flex items-center gap-2 text-[#1f2933]/80" data-id="element-1545">
                      <Calendar className="w-4 h-4 text-salon-red" data-id="element-1546" />
                      <span className="font-mono text-sm" data-id="element-1547">{city.date}</span>
                    </div>
                    {city.time && <div className="flex items-center gap-2 text-[#1f2933]/80" data-id="element-1548">
                        <Clock className="w-4 h-4 text-salon-red" data-id="element-1549" />
                        <span className="font-bold text-lg" data-id="element-1550">{city.time}</span>
                      </div>}
                  </div>

                  {city.earlyBirdDeadline && <div className="mb-4 p-3 bg-salon-yellow/10 border border-salon-yellow rounded" data-id="element-1551">
                      <p className="text-xs font-mono text-[#1f2933] mb-1" data-id="element-1552">
                        <span className="font-bold" data-id="element-1553">EARLY BIRD:</span> ₦35,000
                      </p>
                      <p className="text-xs text-[#9ca3af]" data-id="element-1554">
                        Valid until {city.earlyBirdDeadline}
                      </p>
                      <p className="text-xs text-[#9ca3af] mt-1" data-id="element-1555">
                        Regular: ₦50,000
                      </p>
                    </div>}

                  {city.note && <div className="mb-4 p-2 bg-salon-yellow/10 border border-salon-yellow text-xs text-[#1f2933]/80 rounded" data-id="element-1556">
                      {city.note}
                    </div>}

                  <Button className="w-full bg-[#1f2933] hover:bg-salon-red border-[#1f2933] hover:border-salon-red text-white" onClick={() => handleCitySelect(city.id)} data-id="element-1557">
                    REGISTER_FOR_{city.name.toUpperCase()}
                  </Button>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* REGISTRATION FORM */}
      {isRegistering && <section id="registration-form" className="py-24 bg-[#1f2933] text-white" data-id="element-1558">
          <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8" data-id="element-1559">
            <div className="text-center mb-8" data-id="element-1560">
              <h2 className="text-3xl font-bold mb-2" data-id="element-1561">Complete Registration</h2>
              <p className="font-mono text-sm text-[#9ca3af]" data-id="element-1562">
                Step {currentStep} of 3 •{' '}
                {cities.find(c => c.id === selectedCityId)?.name} Edition
              </p>
            </div>

            <div className="bg-white text-[#1f2933] p-8 rounded-lg shadow-xl" data-id="element-1563">
              {/* Step 1: Personal Info */}
              {currentStep === 1 && <div className="space-y-6" data-id="element-1564">
                  <h3 className="text-xl font-bold border-b border-dashed border-[#9ca3af] pb-4" data-id="element-1565">
                    Personal Information
                  </h3>
                  <div data-id="element-1566">
                    <label className="block text-xs font-mono text-[#9ca3af] mb-1" data-id="element-1567">
                      FULL_NAME
                    </label>
                    <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} className="w-full border-2 border-[#9ca3af] px-4 py-3 font-mono text-sm focus:border-salon-red focus:outline-none" placeholder="Enter your full name" data-id="element-1568" />
                  </div>
                  <div data-id="element-1569">
                    <label className="block text-xs font-mono text-[#9ca3af] mb-1" data-id="element-1570">
                      EMAIL_ADDRESS
                    </label>
                    <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full border-2 border-[#9ca3af] px-4 py-3 font-mono text-sm focus:border-salon-red focus:outline-none" placeholder="Enter your email" data-id="element-1571" />
                  </div>
                  <div data-id="element-1572">
                    <label className="block text-xs font-mono text-[#9ca3af] mb-1" data-id="element-1573">
                      PHONE_NUMBER
                    </label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} className="w-full border-2 border-[#9ca3af] px-4 py-3 font-mono text-sm focus:border-salon-red focus:outline-none" placeholder="Enter your phone number" data-id="element-1574" />
                  </div>
                  <Button onClick={nextStep} className="w-full bg-salon-red border-salon-red text-white" data-id="element-1575">
                    NEXT_STEP
                  </Button>
                </div>}

              {/* Step 2: Professional Info */}
              {currentStep === 2 && <div className="space-y-6" data-id="element-1576">
                  <h3 className="text-xl font-bold border-b border-dashed border-[#9ca3af] pb-4" data-id="element-1577">
                    Professional Information
                  </h3>
                  <div data-id="element-1578">
                    <label className="block text-xs font-mono text-[#9ca3af] mb-1" data-id="element-1579">
                      AREA_OF_EXPERTISE
                    </label>
                    <input type="text" name="expertise" value={formData.expertise} onChange={handleInputChange} className="w-full border-2 border-[#9ca3af] px-4 py-3 font-mono text-sm focus:border-salon-red focus:outline-none" placeholder="What do you do?" data-id="element-1580" />
                  </div>
                  <div data-id="element-1581">
                    <label className="block text-xs font-mono text-[#9ca3af] mb-1" data-id="element-1582">
                      GOAL_FOR_ATTENDING
                    </label>
                    <textarea name="goal" value={formData.goal} onChange={handleInputChange} rows={4} className="w-full border-2 border-[#9ca3af] px-4 py-3 font-mono text-sm focus:border-salon-red focus:outline-none" placeholder="What do you hope to achieve?" data-id="element-1583" />
                  </div>
                  <div className="flex gap-4" data-id="element-1584">
                    <Button variant="secondary" onClick={prevStep} className="flex-1" data-id="element-1585">
                      BACK
                    </Button>
                    <Button onClick={nextStep} className="flex-1 bg-salon-red border-salon-red text-white" data-id="element-1586">
                      NEXT_STEP
                    </Button>
                  </div>
                </div>}

              {/* Step 3: Community Check & Payment */}
              {currentStep === 3 && <div className="space-y-6" data-id="element-1587">
                  <h3 className="text-xl font-bold border-b border-dashed border-[#9ca3af] pb-4" data-id="element-1588">
                    Community Check
                  </h3>
                  <p className="text-sm text-[#1f2933]/70 mb-4" data-id="element-1589">
                    Are you following The Networking Salon on these platforms?
                  </p>

                  <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-1590">
                    {['Instagram', 'Twitter/X', 'TikTok', 'Facebook'].map(platform => <div key={platform} className="border border-[#9ca3af] p-3 rounded" data-id="element-1591">
                          <p className="font-bold text-sm mb-2" data-id="element-1592">{platform}</p>
                          <select name={platform.toLowerCase().replace('/x', '')} value={formData[platform.toLowerCase().replace('/x', '') as keyof typeof formData]} onChange={handleInputChange} className="w-full border border-[#9ca3af] p-1 text-sm" data-id="element-1593">
                            <option value="" data-id="element-1594">Select...</option>
                            <option value="yes" data-id="element-1595">Yes</option>
                            <option value="no" data-id="element-1596">No</option>
                          </select>
                        </div>)}
                  </div>

                  <div className="bg-[#f5f5f7] p-4 rounded mb-6" data-id="element-1597">
                    {selectedCityId !== 'canada' && <>
                        <div className="flex justify-between items-center mb-2" data-id="element-1598">
                          <span className="font-bold" data-id="element-1599">Early Bird Price:</span>
                          <span className="font-mono text-xl font-bold text-salon-red" data-id="element-1600">
                            ₦35,000
                          </span>
                        </div>
                        <p className="text-xs text-[#9ca3af] mb-2" data-id="element-1601">
                          Valid until 1 month before event
                        </p>
                        <p className="text-xs text-[#9ca3af]" data-id="element-1602">
                          Regular price: ₦50,000
                        </p>
                      </>}
                    {selectedCityId === 'canada' && <>
                        <div className="flex justify-between items-center mb-2" data-id="element-1603">
                          <span className="font-bold" data-id="element-1604">Total Payment:</span>
                          <span className="font-mono text-xl font-bold text-salon-red" data-id="element-1605">
                            $10.00
                          </span>
                        </div>
                        <p className="text-xs text-[#9ca3af]" data-id="element-1606">
                          Includes access to The Authority Engine Program
                        </p>
                      </>}
                  </div>

                  <div className="flex gap-4" data-id="element-1607">
                    <Button variant="secondary" onClick={prevStep} className="flex-1" data-id="element-1608">
                      BACK
                    </Button>
                    <Button onClick={handlePayment} className="flex-1 bg-salon-red border-salon-red text-white" disabled={isSubmitting} data-id="element-1609">
                      {isSubmitting ? <span className="flex items-center gap-2" data-id="element-1610">
                          <Loader2 className="w-4 h-4 animate-spin" data-id="element-1611" />
                          PROCESSING...
                        </span> : 'COMPLETE_REGISTRATION'}
                    </Button>
                  </div>
                </div>}
            </div>
          </div>
        </section>}

      {/* FINAL INVITATION */}
      <section className="py-32 text-center" data-id="element-1612">
        <div className="mx-auto max-w-4xl px-4" data-id="element-1613">
          <h2 className="text-4xl font-bold text-[#1f2933] mb-8" data-id="element-1614">
            You don't need more information. You need alignment.
          </h2>
          <p className="text-lg text-[#1f2933]/70 mb-12 max-w-2xl mx-auto" data-id="element-1615">
            You don't need to be everywhere. You need to be positioned.
            <br data-id="element-1616" />
            You don't need to work harder. You need focus, consistency, and
            leverage.
          </p>
          <Button size="large" className="min-w-[250px] bg-[#1f2933] hover:bg-salon-red hover:text-white border-[#1f2933] text-white" onClick={scrollToCities} data-id="element-1617">
            STEP_INTO_2026
          </Button>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1618" />
    </div>;
}